export default {
  title: {
    line1: "DO YOU WANT TO COLLAB?".toUpperCase(),
    line2: "Do you want to list your project?".toUpperCase(),
    line3: "Any complaints about how we rated your project?".toUpperCase(),
  },
  sub_title: "For anything you want - just talk to us. Vision are not jerks, and we`re ready to talk!".toUpperCase(),
  link: {
    telegram: "VISION SUPPORT on TELEGRAM".toUpperCase(),
    signal: "VISION SUPPORT on signal".toUpperCase(),
    watsapp: "VISION SUPPORT on watsapp".toUpperCase(),
  },
}
